import { Field, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { toKebabCase } from 'src/utils/helpers';

import styles from './SectionHeader.module.css';

type SectionHeaderProps = ComponentProps & {
	fields: {
		Title: Field<string>;
	};
};

export default withDatasourceCheck()<SectionHeaderProps>(SectionHeader);

function SectionHeader(props: SectionHeaderProps): JSX.Element {
	const elementId = props.fields?.Title && props.fields.Title?.value ? toKebabCase(props.fields.Title.value.toLowerCase().trim()) : '';

	return (
		<Text
			tag="h3"
			id={elementId}
			field={props.fields.Title}
			className={`${styles.title} padX maxWidth`}
			data-section-header
			data-display-pdf-download
		/>
	);
}
